import * as React from 'react'
import { ProcesoBreef } from '../ProcesoBreef/ProcesoBreef'
import { Paginator } from '../Paginator/Paginator'
import CircularProgress from '@mui/material/CircularProgress';
import Select from '@mui/material/Select';
import { MenuItem } from '@mui/material';

function Page(props) {

    React.useEffect(() => {
    }, [props.casos, props.page, props.perPage])

    return(
        <React.Fragment>
            {
                props.casos.length === 0 && props.loaded ?
                <div>
                    <div className='empty-emoji'>
                        {
                            props.location.pathname === '/mis-procesos' ? <span>&#128764;</span> :
                            props.location.pathname === '/importantes' ? <span>&#x2b50;</span> :
                            props.location.pathname === '/archivados' ? <span>&#128465;</span> : null
                        }
                    </div>
                    <div className='text-misProcesos'>
                        {
                            props.location.pathname === '/mis-procesos' ? 'No tienes casos aún. ¡Dejanos ayudarte!' :
                            props.location.pathname === '/importantes' ? 'No has marcado casos como importantes aún.' : 'No has archivado casos aún.'
                        }
                    </div>
                </div>
                : props.loaded ?
                <div>
                    <div className="paginator-container">
                        <div className="top-paginator">
                            <Paginator
                                setPage={props.setPage}
                                page={props.page}
                                pages={props.pages}
                                setLoaded={props.setLoaded}
                            />
                        </div>
                    </div>
                    {
                        props.casos !== undefined ? props.casos.map((caseDict) => {
                            return(
                                <ProcesoBreef
                                    key={caseDict.idProceso}
                                    idProceso={caseDict.idProceso}
                                    setOpenCaseInfo={props.setOpenCaseInfo} 
                                    loadCaseBreef={props.loadCaseBreef}
                                    caseDict={caseDict}
                                    url={props.url}/>
                            )
                        }) 
                        : null
                    }
                    <div className="paginator-container">
                        <div className="bottom-paginator">
                            <Paginator
                                setPage={props.setPage}
                                page={props.page}
                                pages={props.pages}
                            />
                        </div>
                        <div className="cases-per-page-container bottom-paginator">   
                            <Select
                                className="pages"
                                fullWidth value={props.perPage}
                                onChange={(e) => props.setPerPage(e.target.value)} label="Casos por página">
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={25}>25</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                            </Select>
                        </div>
                    </div>
                </div>
            :
                    <div>
                        <div className='loading'><CircularProgress /></div>
                        <div className='text-misProcesos'>Wow... nos tienes muy ocupados</div>
                    </div>}
        </React.Fragment>
        
    )
}

export { Page }